<template>
    <div class="search_box">
        <input autocomplete="off" type="text" @focus="searchFocus" class="sea_input" placeholder="古籍名称、朝代、作者、所在册、丛书名" v-model="search_input"  @keyup.enter="search" v-click-outside="onClickOutside"/>
        <span class="search_btn" @click="search">搜索</span>
        <div class="search_content" v-if="recent_searches.length>0||hot_searches" v-show="is_show">
            <ul v-if="recent_searches.length>0">
                <li class="search_title">最近搜索</li>
                <li v-for="(item,index) in recent_searches.slice(0,5)" @click="push(index,item)" v-bind:key="index">{{item}}</li>
            </ul>
            <ul v-if="hot_searches">
                <li class="search_title">热门搜索</li>
                <li v-for="(item,index) in hot_searches" @click="push(index,item.word)" v-bind:key="index">{{item.word}}</li>
            </ul>
        </div>
    </div>
</template>
<script>
import clickOutside from '../../util/bind.js';
export default {
    data(){
        return{
            // input输入值
            search_input:"",
            // 热门搜索
            hot_searches:null,
            //最近搜索
            recent_searches:[],
            // 热门与最近是否显示
            is_show:false
        }
    },
    directives: {
        clickOutside // 注册自定义事件
    },
    created(){
        if(this.$store.state.recent_word!==''){
            this.recent_searches = this.$store.state.recent_word.split(',').reverse()
        }
        if(this.$route.query.wd&&this.$route.path == '/search'){
            this.search_input = this.$route.query.wd
        }
    },
    mounted(){
        this.getHotWord()
    },
    methods:{
        getHotWord(){
            let that = this
            let datas= {
                user_id : that.$store.state.user_id,
                num: 5,
            }
            that.$axios.get("book/hot_word",{
                params:datas
            })
            .then((res)=>{
                // console.log(res)
                if(res.data.status_code==200){
                    that.hot_searches = res.data.data
                }else{
                    return false;
                }
            })
            .catch(function(err){
                return false;
            })
        },
        push(index,item){
            this.search_input = item
            // console.log(item)
            this.$store.commit('setRecentWord', this.search_input)
            this.$router.push({
                path: '/search',
                query: {
                    wd: this.search_input
                }
            })
        },
        search(){
            // console.log('dddddd')
            if(this.search_input.length>0){
                this.$store.commit('setRecentWord', this.search_input)
                this.$router.push({
                    path: '/search',
                    query: {
                        wd: this.search_input
                    }
                })
            }
        },
        searchFocus(){
            // console.log('9999999')
            this.is_show = true
        },
        onClickOutside(){
            // console.log('ddddd')
            this.is_show = false
        }
    }
}
</script>
<style scoped lang="scss"  type="text/css">
    .search_box{
        position:relative;
        display:inline-block;
        margin:0 auto;
        width:930px;
        .sea_input{
            width:930px;
            height:50px;
            box-shadow:0px 3px 5px 0px rgba(72,72,72,0.18);
            border:none;
            outline:none;
            padding-left:56px;
            background:#fff url('../../assets/search/search_icon@2x.png') no-repeat 10px center;
            background-size:22px;
            color:#484848;
            font-family:PingFangSC-Regular;
            font-weight:400;
            font-size:16px;
            border-radius:6px;
            box-sizing:border-box;
            &::-webkit-input-placeholder { /* WebKit, Blink, Edge */
                color:#909090;
                font-size:16px;
            }
            &:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
                color:#909090;
                font-size:16px;
            }
            &::-moz-placeholder { /* Mozilla Firefox 19+ */
                color:#909090;
                font-size:16px;
            }
            &:-ms-input-placeholder { /* Internet Explorer 10-11 */
                color:#909090;
                font-size:16px;
            }
        }
        .search_btn{
            position: absolute;
            right:0;
            top:0;
            width:120px;
            height:50px;
            cursor: pointer;
            border-radius: 0 6px 6px 0;
            background-color:#FF5722;
            line-height:50px;
            color:#fff;
            font-size:20px;
            font-family:PingFangSC-Light;
            font-weight:300;
            text-align:center;
            z-index:40;
        }
        .search_content{
            width: 420px;
            box-sizing: border-box;
            position: absolute;
            top: 60px;
            left: 20px;
            z-index: 99;
            background: #fff;
            // box-shadow: 0 0 15px rgba(119, 80, 35, 0.23); 
            box-shadow:0px 5px 14px 0px rgba(119,80,35,0.23);
            padding:9px 0 19px 0;
            z-index:100;
            .search_title{
                height: 32px;
                line-height: 32px;
                font-size: 14px;
                color: #999;
                &:hover{
                    background: #fff;
                }
            }
            li{
                width: 100%;
                height: 32px;
                line-height: 32px;
                padding-left: 20px;
                color: #333;
                box-sizing: border-box;
                font-size: 14px;
                &:hover{
                    background: #FFF1E0;
                }
            }
        }
    }
    
</style>





// WEBPACK FOOTER //
// src/components/public/searchBox.vue